const HOME_MAP = {
  daily_exercise: '/daily-exercise',
  daily_exercises: '/daily-exercise',
  self_reflect: "/daily-reflection",
  goals: "/goals",
  progress: "/progress",
  courses: "/courses",
  assessments: "/c/assessments"
};

export default HOME_MAP;
